import { render, staticRenderFns } from "./shuju.vue?vue&type=template&id=29567732&scoped=true"
import script from "./shuju.vue?vue&type=script&lang=js"
export * from "./shuju.vue?vue&type=script&lang=js"
import style0 from "./shuju.vue?vue&type=style&index=0&id=29567732&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29567732",
  null
  
)

export default component.exports